export default __webpack_public_path__ + "static/media/health-profile.93ee1a50.webp";